var render = function render(_c,_vm){return _c('b-badge',{staticClass:"text-uppercase font-weight-500",class:[(_vm.data.staticClass || ''), (_vm.data.class || '')],attrs:{"variant":_vm.props.tag.color_variant || 'secondary'}},[_vm._v(" "+_vm._s(_vm.props.tag.name)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }